/**
* This file contains all the action type constants, all the constants to be
* exported. use UPPER_CASE_SNAKE_CASE for constant name. below is example for reference.
*/
export const NAVIGATION_BLOCKER = 'NAVIGATION_BLOCKER';
export const NAVIGATION_UNBLOCKER = 'NAVIGATION_UNBLOCKER';
export const SET_PREVIOUS_PATH = 'SET_PREVIOUS_PATH';
export const MFA_CONFIG_REQUESTED = 'MFA_CONFIG_REQUESTED';
export const MFA_CONFIG_RESPONDED = 'MFA_CONFIG_RESPONDED';
export const MFA_CONFIG_ERROR = 'MFA_CONFIG_ERROR';
export const NAVIGATE = 'NAVIGATE';
export const OKTA_TOKEN_REQUESTED = 'OKTA_TOKEN_REQUESTED';
export const OKTA_TOKEN_RESPONDED = 'OKTA_TOKEN_RESPONDED';
export const USER_DETAILS_REQUESTED = 'USER_DETAILS_REQUESTED';
export const USER_DETAILS_RESPONDED = 'USER_DETAILS_RESPONDED';
export const USER_DETAILS_ERROR = 'USER_DETAILS_ERROR';
export const SET_USERS_ERROR_MESSAGES = 'SET_USERS_ERROR_MESSAGES';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const CLEAR_HELPER_TEXT_MESSAGES = 'CLEAR_HELPER_TEXT_MESSAGES';
export const UPDATE_PROFILE_DETAILS = 'UPDATE_PROFILE_DETAILS';
export const UPDATE_PROFILE_DETAILS_SUCCESS = 'UPDATE_PROFILE_DETAILS_SUCCESS';
export const UPDATE_PROFILE_DETAILS_ERROR = 'UPDATE_PROFILE_DETAILS_ERROR';
export const USER_DETAILS_AFTER_UPDATE = 'USER_DETAILS_AFTER_UPDATE';
export const CLOSE_TOAST_MESSAGE = 'CLOSE_TOAST_MESSAGE';
export const OKTA_NEW_TOKEN_REQUESTED = 'OKTA_NEW_TOKEN_REQUESTED';
export const OKTA_NEW_TOKEN_FAILURE = 'OKTA_NEW_TOKEN_FAILURE';
export const CLOSE_CONTAINER_TOAST = 'CLOSE_CONTAINER_TOAST';
export const SHOW_CONTAINER_TOAST = 'SHOW_CONTAINER_TOAST';
export const RESET_RETRY_COUNT = 'RESET_RETRY_COUNT';
export const RESET_TIMER = 'RESET_TIMER';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_LIST_SUCCESS = 'GET_COUNTRIES_LIST_SUCCESS';
export const GET_COUNTRIES_LIST_ERROR = 'GET_COUNTRIES_LIST_ERROR';
export const TOGGLE_SIDEBAR_HIDE = 'TOGGLE_SIDEBAR_HIDE';
export const TOGGLE_SIDEBAR_SHOW = 'TOGGLE_SIDEBAR_SHOW';
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN';
export const LOADERS_REQUESTED = 'LOADERS_REQUESTED';
export const LOADERS_RESPONDED = 'LOADERS_RESPONED';
export const NOTIFICATIONS_POLL = 'NOTIFICATIONS_POLL';
export const NOTIFICATIONS_POLL_RESPONDED = 'NOTIFICATIONS_POLL_RESPONDED';
export const NOTIFICATIONS_GET_MSGS = 'NOTIFICATIONS_GET_MSGS';
export const NOTIFICATIONS_GET_MSGS_SUCCESS = 'NOTIFICATIONS_GET_MSGS_SUCCESS';
export const NOTIFICATIONS_MARK_ARCHIVE = 'NOTIFICATIONS_MARK_ARCHIVE';
export const NOTIFICATIONS_MARK_ARCHIVE_SUCCESS = 'NOTIFICATIONS_MARK_ARCHIVE_SUCCESS';
export const CREATE_USER_IN_AMP = 'CREATE_USER_IN_AMP';

export const FETCH_USER_ENTITLED_APPS = 'FETCH_USER_ENTITLED_APPS';
export const FETCH_USER_ENTITLED_APPS_SUCCESS = 'FETCH_USER_ENTITLED_APPS_SUCCESS';
export const FETCH_USER_ENTITLED_APPS_ERROR = 'FETCH_USER_ENTITLED_APPS_ERROR';
export const CLOSE_ERROR_TOAST = 'CLOSE_ERROR_TOAST';
export const UPDATE_USER_ONBOARD_STATUS = 'UPDATE_USER_ONBOARD_STATUS';
export const UPDATE_USER_ONBOARD_STATUS_ERROR = 'UPDATE_USER_ONBOARD_STATUS_ERROR';

export const SET_FEATURE_FLAGS_LOADED = 'SET_FEATURE_FLAGS_LOADED';
export const SET_SHOW_NEW_UI = 'SET_SHOW_NEW_UI';
/** #genai Evone banner visibility (EVONE entitlements + LaunchDarkly) */
export const SET_EVONE_BANNER_VISIBILITY = 'SET_EVONE_BANNER_VISIBILITY';
/** #genai LaunchDarkly showHorizonBanner stored for sync with third-party fetch */
export const SET_EVONE_LD_SHOW_BANNER = 'SET_EVONE_LD_SHOW_BANNER';

export const GET_USER_ONBOARDING_STATUS = 'GET_USER_ONBOARDING_STATUS';
export const GET_USER_ONBOARDING_STATUS_SUCCESS = 'GET_USER_ONBOARDING_STATUS_SUCCESS';
export const GET_USER_ONBOARDING_STATUS_ERROR = 'GET_USER_ONBOARDING_STATUS_ERROR';
export const SET_AUTOPROVISION = 'SET_AUTOPROVISION';
export const AUTO_PROVISION_STATUS = 'AUTO_PROVISION_STATUS';

export const REVOKE_ACCESS_TOKEN = 'REVOKE_ACCESS_TOKEN';

export const GET_CUSTOM_TOKEN = 'GET_CUSTOM_TOKEN';
export const EXPIRE_GUID = 'EXPIRE_GUID';

export const VALIDATE_USER_IMPERSONATION = 'VALIDATE_USER_IMPERSONATION';
export const SET_SHOW_RELOAD_DIALOG = 'SET_SHOW_RELOAD_DIALOG';

export const SET_SIGN_OUT_DISABLED = 'SET_SIGN_OUT_DISABLED';
export const SET_IS_SHARE_TOKEN = 'SET_IS_SHARE_TOKEN';

export const FETCH_SHARED_APP_CONFIG = 'FETCH_SHARED_APP_CONFIG';
export const GUEST_USER_DETAILS_REQUESTED = 'GUEST_USER_DETAILS_REQUESTED';
